// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHsaCustodianTypeDto
 */
export interface IHsaCustodianTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IHsaCustodianTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHsaCustodianTypeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IHsaCustodianTypeDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IHsaCustodianTypeDto interface.
 */
export function instanceOfIHsaCustodianTypeDto(value: object): value is IHsaCustodianTypeDto {
    return true;
}

export function IHsaCustodianTypeDtoFromJSON(json: any): IHsaCustodianTypeDto {
    return IHsaCustodianTypeDtoFromJSONTyped(json, false);
}

export function IHsaCustodianTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHsaCustodianTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IHsaCustodianTypeDtoToJSON(json: any): IHsaCustodianTypeDto {
    return IHsaCustodianTypeDtoToJSONTyped(json, false);
}

export function IHsaCustodianTypeDtoToJSONTyped(value?: IHsaCustodianTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

